/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { Popover, Typography } from "antd";
import PopOverCrew from "./PopOverCrew";

function CrewCard(props: any) {
  const {
    column,
    crewDrop,
    setColumns,
    allColumns,
    isWeekend,
    selectedDate,
    index,
  } = props;

  const isToday = selectedDate
    ? new Date(selectedDate).toDateString() === new Date().toDateString()
    : false;

  const [open, setOpen] = useState(false);
  const [editCrew, setEditCrew] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setEditCrew(false);
    setOpen(newOpen);
  };

  return (
    <div
      className="column_info_item"
      style={{ width: "76px", marginLeft: "auto", cursor: "pointer" }}
    >
      <Popover
        trigger="click"
        arrow={false}
        placement="bottomLeft"
        open={open}
        onOpenChange={handleOpenChange}
        content={
          <PopOverCrew
            column={column}
            editCrew={editCrew}
            crewDrop={crewDrop}
            setEditCrew={setEditCrew}
            allColumns={allColumns}
            setColumns={setColumns}
          />
        }
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            marginBottom: "4px",
          }}
        >
          Crew
          {!isWeekend && isToday && index === 0 && (
            <img src="/images/potential-deals/octagon-warning.svg" alt="" />
          )}
        </span>

        {isWeekend ? (
          <Typography.Text
            type="secondary"
            style={{
              fontSize: "12px",
              color: "#151718",
              display: "block",
              textAlign: "left",
              fontWeight: 600,
            }}
          >
            0
          </Typography.Text>
        ) : (
          <div className="crewDotsWrapper">
            {column?.crewMembers?.length || 0}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "4px",
                width: "100%",
                paddingLeft: "6px",
              }}
            >
              {column?.crewMembers?.map((member: any) =>
                !isToday ? (
                  <span
                    key={member.id}
                    className="crewDots"
                    style={{ backgroundColor: "#DEE5E6" }}
                  />
                ) : member?.punchedIn || member?.latePunchedIn ? (
                  <span key={member.id} className="crewDots" />
                ) : (
                  <span
                    key={member.id}
                    className="crewDots"
                    style={{ backgroundColor: "#D33D3D" }}
                  />
                )
              )}
            </div>
          </div>
        )}
      </Popover>
    </div>
  );
}

export default CrewCard;
